import _ from 'underscore'

import WindowLocation from 'helpers/windowLocation'

const RESIDENTIAL_BUSINESS_UNIT = 'residential'
const COMMERCIAL_BUSINESS_UNIT = 'commercial'

export type ValidBrandNamesType = 'trane_home' | 'asair_home' | 'trane'

const BRANDS = {
  trane_home: {
    brandName: 'Trane®',
    domainName: 'tranehome',
    dealerKitUrl: 'https://my.visme.co/view/01yrz6n6-g8n5oprvnnyy2qvz',
    businessUnit: RESIDENTIAL_BUSINESS_UNIT,
    productName: 'Trane® Diagnostics',
    productLogoPath: '/img/trane_product_logo.svg',
    premiumProductLogoPath: '/img/premium_trane_product_logo.svg',
    premiumProductMeatballPath: '/img/premium_trane_meatball.svg',
    brandLogoPath: '/img/trane_home_brand_logo.svg',
    faviconPath: '/img/favicon_trane.svg',
    consumerPortal: 'Trane® Home',
    supportPhone: '1.877.288.7707',
    supportEmail: 'dealerdiags@tranehome.zendesk.com',
    alertGuidePdf: '/img/pdf/TR_Alarm-Guide-Booklet.pdf',
    idpDomain: 'comfortsite',
    idpName: 'comfortsite',
    devApptentiveFeedbackEvent: 'trane_dwa_dev_feedback_button',
    prodApptentiveFeedbackEvent: 'trane_dwa_prod_feedback_button',
    premiumBackgroundPath: '/img/premium_trane.png',
    accentColor: '#EF4723',
    noReplySender: 'no-reply@tranehome.com'
  },
  asair_home: {
    brandName: 'American Standard®',
    domainName: 'asairhome',
    dealerKitUrl: 'https://my.visme.co/view/6xmy6ver-pmjlj0w769mk2z39',
    businessUnit: RESIDENTIAL_BUSINESS_UNIT,
    productName: 'American Standard® Diagnostics',
    productLogoPath: '/img/asair_product_logo.svg',
    premiumProductLogoPath: '/img/premium_asair_product_logo.svg',
    premiumProductMeatballPath: '/img/premium_asair_meatball.svg',
    brandLogoPath: '/img/asair_brand_logo.svg',
    faviconPath: '/img/favicon_asair_home.svg',
    consumerPortal: 'American Standard® Home',
    supportPhone: '1.877.374.0697',
    supportEmail: 'dealerdiags@asairhome.zendesk.com',
    alertGuidePdf: '/img/pdf/AMST_Alarm-Guide-Booklet.pdf',
    idpDomain: 'asdealernet',
    idpName: 'dealernet',
    devApptentiveFeedbackEvent: 'as_dwa_dev_feedback_button',
    prodApptentiveFeedbackEvent: 'as_dwa_prod_feedback_button',
    premiumBackgroundPath: '/img/premium_as.png',
    accentColor: '#2C7AC2',
    noReplySender: 'no-reply@asairhome.com'
  },
  trane: {
    brandName: 'Trane®',
    domainName: 'trane',
    dealerKitUrl: undefined,
    businessUnit: COMMERCIAL_BUSINESS_UNIT,
    productName: 'Trane® Commercial',
    brandLogoPath: '/img/trane_commercial_brand_logo.svg',
    productLogoPath: '/img/trane_product_logo.svg',
    premiumProductLogoPath: '/img/premium_trane_product_logo.svg',
    premiumProductMeatballPath: '/img/premium_trane_meatball.svg',
    faviconPath: '/img/favicon_trane.svg',
    consumerPortal: 'Trane® Pivot',
    supportPhone: '1.833.222.3201',
    supportEmail: 'PivotDiagnosticsSupport@trane.com',
    alertGuidePdf: '/img/pdf/TR_Alarm-Guide-Booklet.pdf',
    idpDomain: 'comfortsite',
    idpName: 'comfortsite',
    devApptentiveFeedbackEvent: 'trane_dwa_dev_feedback_button',
    prodApptentiveFeedbackEvent: 'trane_dwa_prod_feedback_button',
    premiumBackgroundPath: '/img/premium_trane.png',
    accentColor: '#EF4723',
    noReplySender: 'no-reply@tranehome.com'
  }
}

class Brand {
  static initialize () {
    $('body').attr('data-brand', Brand.current())
  }

  static current () {
    if (WindowLocation.hostname().match(/tranehome[-.]/)) {
      return 'trane_home'
    } else if (WindowLocation.hostname().match(/asairhome[-.]/)) {
      return 'asair_home'
    } else if (WindowLocation.hostname().match(/trane[-.]/)) {
      return 'trane'
    } else if (WindowLocation.hostname().match(/tranetechdev/)) {
      return 'trane_home'
    } else {
      return 'trane_home'
    }
  }

  static isResidential () {
    return Brand.current() && BRANDS[Brand.current()].businessUnit === RESIDENTIAL_BUSINESS_UNIT
  }

  static isCommercial () {
    return Brand.current() && BRANDS[Brand.current()].businessUnit === COMMERCIAL_BUSINESS_UNIT
  }

  static isTraneHome () {
    return Brand.current() === 'trane_home'
  }

  static isASAirHome () {
    return Brand.current() === 'asair_home'
  }

  static isTrane () {
    return Brand.current() === 'trane'
  }

  static allBrandsOfCurrentBusinessUnit () {
    if (!Brand.current()) {
      return []
    }

    const businessUnit = BRANDS[Brand.current()].businessUnit

    return _.select(_.keys(BRANDS), (brand) => BRANDS[brand].businessUnit === businessUnit)
  }

  // Helper methods for attributes on current brand
  static brandLogoPath (brand = null) {
    return BRANDS[brand || Brand.current()].brandLogoPath
  }

  static brandName (brand = null) {
    return BRANDS[brand || Brand.current()].brandName
  }

  static productLogoPath (brand = null) {
    return BRANDS[brand || Brand.current()].productLogoPath
  }

  static premiumBackgroundPath (brand = null) {
    return BRANDS[brand || Brand.current()].premiumBackgroundPath
  }

  static premiumProductMeatballPath (brand = null) {
    return BRANDS[brand || Brand.current()].premiumProductMeatballPath
  }

  static premiumProductLogoPath (brand = null) {
    return BRANDS[brand || Brand.current()].premiumProductLogoPath
  }

  static accentColor (brand = null) {
    return BRANDS[brand || Brand.current()].accentColor
  }

  static domainName (brand = null) {
    return BRANDS[brand || Brand.current()].domainName
  }

  static dealerKitUrl (brand = null) {
    return BRANDS[brand || Brand.current()].dealerKitUrl
  }

  static businessUnit (brand = null) {
    return BRANDS[brand || Brand.current()].businessUnit
  }

  static productName (brand = null) {
    return BRANDS[brand || Brand.current()].productName
  }

  static faviconPath (brand = null) {
    return BRANDS[brand || Brand.current()].faviconPath
  }

  static consumerPortal (brand = null) {
    return BRANDS[brand || Brand.current()].consumerPortal
  }

  static supportPhone (brand = null) {
    return BRANDS[brand || Brand.current()].supportPhone
  }

  static supportEmail (brand = null) {
    return BRANDS[brand || Brand.current()].supportEmail
  }

  static alertGuidePdf (brand = null) {
    return BRANDS[brand || Brand.current()].alertGuidePdf
  }

  static idpDomain (brand = null) {
    return BRANDS[brand || Brand.current()].idpDomain
  }

  static idpName (brand = null) {
    return BRANDS[brand || Brand.current()].idpName
  }

  static devApptentiveFeedbackForm (brand = null) {
    return BRANDS[brand || Brand.current()].devApptentiveFeedbackEvent
  }

  static prodApptentiveFeedbackForm (brand = null) {
    return BRANDS[brand || Brand.current()].prodApptentiveFeedbackEvent
  }

  static noReplySender (brand = null) {
    return BRANDS[brand || Brand.current()].noReplySender
  }
}

export default Brand
